import {
  ViewSection,
  ViewSectionContent,
  ViewSectionHeader,
  ViewSectionTitle,
} from '@fortem-monorepo/react-spa'
import { ICGG2Report } from '@fortem-monorepo/web-sdk'

import { ContentBlocks } from '@/components/content-blocks/ContentBlocks'
import { IC_GUIDELINES_DATA_GRID_OVERRIDES } from '@/pages/funds/ic-guidelines-v2/content-block-config'

export interface SummaryStageProps {
  output: ICGG2Report.NormalStageOutput
}

export const SummaryStage: React.FC<SummaryStageProps> = ({ output }) => {
  const blocks = output.blocks ?? []

  if (!blocks.length) {
    return null
  }

  return (
    <ViewSection>
      <ViewSectionHeader>
        <ViewSectionTitle>Summary</ViewSectionTitle>
      </ViewSectionHeader>
      <ViewSectionContent>
        <ContentBlocks blocks={blocks} dataGridOverrides={IC_GUIDELINES_DATA_GRID_OVERRIDES} />
      </ViewSectionContent>
    </ViewSection>
  )
}

{
  /* <div className="flex flex-col gap-4">
          {hasAnyRows(headline, crossHoldings, currencyExposures) && (
            <div className="flex gap-4">
              <GridWidget title="Headline" className={'w-85 shrink-0'}>
                {hasRows(headline) && <HeadlineTable rowData={headline} />}
              </GridWidget>
              <div className="flex flex-col gap-4 w-full">
                <GridWidget title="Cross Holdings">
                  {hasRows(crossHoldings) && <CrossHoldingsTable rowData={crossHoldings} />}
                </GridWidget>
                <GridWidget title="Currency Exposures">
                  {hasRows(currencyExposures) && (
                    <CurrencyExposuresTable rowData={currencyExposures} />
                  )}
                </GridWidget>
              </div>
            </div>
          )}
          {hasRows(mtm) && (
            <GridWidget title="MTM">
              <MtmTable rowData={mtmData} />
            </GridWidget>
          )}
        </div> */
}
